import { createTheme } from "@mui/material/styles";

const rootTheme = createTheme({
  palette: {
    primary: {
      main: "#0095c6",
    },
    secondary: {
      main: "#f50057",
    },
    background: {
      default: "#FaFaFa",
    },
  },
  layout: {
    drawerWidth: 260,
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: { borderRadius: "20px" },
        containedPrimary: {
          fontWeight: "bold",
          fontSize: "0.775rem",
        },
        outlinedPrimary: {
          fontWeight: "bold",
          fontSize: "0.775rem",
        },
        containedSecondary: {
          fontWeight: "bold",
          fontSize: "0.775rem",
        },
        outlinedSecondary: {
          fontWeight: "bold",
          fontSize: "0.775rem",
        },
      },
    },
    MuiFormHelperText: {
      styleOverrides: {
        root: {
          marginLeft: 0,
        },
      },
    },
  },
});

export default rootTheme;
